module.exports = __webpack_public_path__ + "01144873c76fdf96156c429557c9f749.fbx";